import * as React from 'react';
import MuiTypography, { TypographyProps } from '@mui/material/Typography';

export function Typography(props: TypographyProps) {
  const { children, ...rest } = props;
  return <MuiTypography {...rest}>{children}</MuiTypography>;
}
